import { Card, Grid, CardHeader, MenuItem } from '@material-ui/core';
import { Formik, Field, Form } from 'formik';
import { TextField as FormikTextField } from 'formik-material-ui';
import React from 'react';
import { useStyles } from 'components/Shared/DynamicForm';
import AuthCheck from 'components/Shared/AuthCheck';
import DataGrid from 'components/AdminConfig/Domains/DataGrid';

const Domains = ({domains}) => {
  const classes = useStyles();

  return (
    <AuthCheck scope="AdminConfig" action="create">
      <Grid container justify="center" style={{ padding: 16 }}>
        <Grid item xl={6} lg={6} md={10} sm={12}>
          <Grid container justify="center">
            <Grid item xs={12}>
              <Card>
                <CardHeader title="Update Domains"></CardHeader>
                <Formik
                  initialValues={{
                    domain: Object.keys(domains)[0]
                  }}
                // onSubmit={handleSubmit}
                // validationSchema={validation}
                >
                  {props =>
                    <>
                      <Form className={classes.VerticalFormStyle} noValidate autoComplete="off">
                        <Field
                          component={FormikTextField}
                          select
                          label="Domain"
                          name="domain"
                          variant="outlined"
                        >
                          {Object.entries(domains).map(([k, v]) => (
                            <MenuItem value={k} key={k}>{v.label}</MenuItem>
                          ))}
                        </Field>
                      </Form>
                      {
                        props.values.domain.length > 0 &&
                        <DataGrid {...props} domains={domains} />
                      }
                    </>
                  }
                </Formik>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AuthCheck>
  )

};

export default Domains;